const lsg_press_hits = { 
    init: () => {
        

        const parentEls = document.querySelectorAll(`.lsg-press-hits`);

        parentEls.forEach((parentEl) => {

            const wrapperEl     = parentEl.querySelector(`.lsg-press-hits__wrapper`),
                  logoEls       = parentEl.querySelectorAll(`.lsg-press-hits__logo`),
                  carouselEl    = parentEl.querySelector(`.lsg-press-hits__carousel-wrapper`);
        
            if (wrapperEl.getAttribute(`lsg-quote-fader`) === "true") {
                logoEls.forEach((logoEl) => {
                    logoEl.addEventListener('click', (e) => {
                        const quote = logoEl.getAttribute(`lsg-quote`);
                        wrapperEl.setAttribute(`lsg-active-quote`, quote);
                    });
                });
            }

            const carousel = new Flickity(carouselEl, {
                wrapAround: true,
                // groupCells: true,
                pageDots: true,
                prevNextButtons: true,
                centerMode: true,
                imagesLoaded: true,
            });

            // Temporary hack for weird bug
            document.addEventListener('DOMContentLoaded', function () {
                setTimeout(function () {  
                    window.dispatchEvent(new Event('resize')); // flickity fix
                }, 200);
            });

        });


    }
}
export default lsg_press_hits;